export default {
  common: {
    appName: 'Honey Badger Entertainment',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    submit: 'Gửi',
    save: 'Lưu',
    usernameRequired: 'Vui lòng nhập tên đăng nhập!',
    passwordRequired: 'Vui lòng nhập mật khẩu!',
    viewMore: 'Xem thêm',
    refreshSuccess: 'Làm mới thành công',
    noMore: 'Không còn nữa',
    emptyData: 'Chưa có dữ liệu',
  },
  footer: { home: 'Trang chủ', lottery: 'Xổ số', game: 'Đặt trước', video: 'Video', mine: 'Cá nhân' },
  lang: { title: 'Ngôn ngữ / Language', current: 'Ngôn ngữ hiện tại' },
  home: {
    recommendedTasks: 'Nhiệm vụ đề xuất',
    popularRanking: 'Xếp hạng phổ biến',
    hotRecommend: 'Gợi ý nổi bật',
    playCount: 'Lượt xem: {count}',
    noticeLoading: 'Đang tải...',
  },
  game: {
    hallTitle: 'Sảnh đặt trước',
    categoryAll: 'Tất cả',
  },
  choose: {
    title: 'Người đồng hành',
    tabCities: 'Danh sách thành phố',
    tabProcess: 'Quy trình & giá',
    privacyNotice: 'Nền tảng có những người đồng hành, bạn đồng hành công tác và các cuộc gặp gỡ tại chỗ chân thực nhất trên mạng. Để bảo vệ riêng tư của mỗi người dùng, khách hàng chỉ có thể tham gia qua tiếp tân hoặc được hội viên kỳ cựu giới thiệu thực danh.',
    resourcesQ: 'Có những lựa chọn nào?',
    resourcesA: 'Người nổi tiếng, người mẫu, tiếp viên hàng không, mẫu trẻ, sinh viên — chỉ cần bạn nghĩ đến, nền tảng đều có thể đáp ứng.',
    scopeQ: 'Phạm vi phục vụ?',
    scopeA: 'Gặp gỡ miễn phí trong cùng thành phố, có mặt tại bất kỳ đâu trên cả nước. Có sẵn tại các thành phố lớn bậc một, bậc hai; thành phố bậc ba có thể sắp xếp qua tiếp tân.',
    book: 'Đặt trước',
    contactConcierge: 'Vui lòng liên hệ chuyên viên hoặc tiếp tân',
    cityNames: {
      beijing: 'Bắc Kinh',
      shanghai: 'Thượng Hải',
      guangzhou: 'Quảng Châu',
      shenzhen: 'Thâm Quyến',
      nanjing: 'Nam Kinh',
      changsha: 'Trường Sa',
      chongqing: 'Trùng Khánh',
      xian: 'Tây An',
    },
  },
  lottery: {
    gameRecord: 'Lịch sử nhiệm vụ',
    orderList: 'Phiếu nhiệm vụ',
    orderItemDetail: '1 cược X {money} = {money}',
    clearOrder: 'Xóa phiếu',
    confirmSubmit: 'Xác nhận gửi',
    availableBalance: 'Số dư khả dụng',
    yuan: 'đồng',
    currentPick: 'Lựa chọn hiện tại: ',
    amountPerBet: 'Số tiền mỗi cược: ',
    amountPlaceholder: 'Nhập số tiền',
    amountInvalid: 'Số tiền không hợp lệ!',
    fillAmount: 'Vui lòng nhập số tiền!',
    selectNumberFirst: 'Vui lòng chọn số!',
    insufficientBalance: 'Số dư không đủ, vui lòng liên hệ dịch vụ khách hàng để nạp tiền!',
    notSelected: 'Chưa chọn',
    contactAdminForTask: 'Vui lòng liên hệ quản trị viên để nhận nhiệm vụ này!',
    drawSuccess: 'Đã công bố kết quả, kỳ: {expect}',
    periodNumber: 'Kỳ',
    betUnit: 'lượt',
    totalAmountLabel: 'Tổng tiền: ',
    totalCountLabel: 'Tổng số lượt: ',
    drawResult: 'Số trúng thưởng',
    big: 'Lớn',
    small: 'Nhỏ',
    single: 'Lẻ',
    doubleNum: 'Chẵn',
    rules: {
      title: 'Luật chơi',
      tipTitle: 'Hướng dẫn chơi',
      tipDetail: 'Chọn số trong các tổng có sẵn để đặt cược.',
      winTitle: 'Quy định thắng',
      winDetail: 'Tổng ba số trúng thưởng từ 11 đến 18 là Lớn; từ 3 đến 10 là Nhỏ.',
      exampleTitle: 'Ví dụ đặt cược',
      exampleDetail: 'Cược: Nhỏ. Số trúng thưởng: 123 — kết quả: Nhỏ.',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'Nạp tiền', withdraw: 'Rút tiền', game: 'Cược' },
    },
    withdraw: {
      amountLabel: 'Số tiền rút (đồng)',
      all: 'Tất cả',
      limitRule1: '1. Hạn mức mỗi lần: tối thiểu {min}, tối đa {max}',
      limitRule2: '2. Số lần rút: tối đa {num} lần mỗi ngày',
      limitRule3: '3. Thời gian nhận tiền: thường khoảng 5 phút, nhanh nhất 2 phút',
      limitTitle: 'Hạn mức rút',
      balanceLabel: 'Số dư: ',
      submit: 'Rút ngay',
      amountInvalid: 'Vui lòng nhập số tiền hợp lệ',
    },
    bindCard: {
      formLabel: 'Vui lòng nhập thông tin thẻ nhận tiền của bạn',
      bankidLabel: 'Số thẻ',
      bankidPlaceholder: 'Nhập số thẻ thật',
      bankLabel: 'Tên ngân hàng',
      bankPlaceholder: 'Chọn ngân hàng',
      notice: 'Kính gửi khách hàng, để bảo đảm an toàn tài sản, vui lòng điền tên thật và đặt mật khẩu rút tiền. Nếu tên không khớp với tên chủ tài khoản, bạn sẽ không thể rút tiền.',
      submit: 'Xác nhận liên kết',
      bankidRequired: 'Vui lòng nhập số thẻ!',
      bankRequired: 'Vui lòng chọn ngân hàng!',
    },
    setbank: {
      title: 'Thẻ nhận tiền',
      addCard: 'Thêm thẻ nhận tiền',
      tips: 'Lưu ý: vui lòng liên kết ngân hàng thương mại lớn. Nếu cần thay đổi, hãy liên hệ dịch vụ khách hàng trực tuyến.',
      setNameFirst: 'Vui lòng đặt tên trước khi liên kết thẻ ngân hàng!',
      setPayPasswordFirst: 'Vui lòng đặt mật khẩu rút tiền trước khi liên kết thẻ ngân hàng!',
    },
    setPayPassword: {
      firstPrompt: 'Nhập mật khẩu rút tiền',
      secondPrompt: 'Nhập lại mật khẩu rút tiền',
      incomplete: 'Vui lòng nhập đầy đủ',
      mismatch: 'Hai mật khẩu không khớp!',
    },
    setLoginPassword: {
      oldPassword: 'Mật khẩu cũ',
      oldPasswordPlaceholder: 'Nhập mật khẩu cũ của bạn',
      newPassword: 'Mật khẩu mới',
      newPasswordPlaceholder: 'Nhập mật khẩu mới của bạn',
      confirmPasswordPlaceholder: 'Nhập lại mật khẩu mới của bạn',
      incomplete: 'Vui lòng nhập đầy đủ!',
      mismatch: 'Hai mật khẩu không khớp',
    },
    setname: {
      nameLabel: 'Họ tên',
      namePlaceholder: 'Nhập tên thật của bạn',
      notice: 'Để bảo mật tài khoản, tên thật phải khớp với tên trên thẻ ngân hàng đã liên kết',
      alreadySet: 'Vui lòng không đặt lại nhiều lần!',
      nameRequired: 'Vui lòng nhập tên của bạn!',
    },
    setsex: {
      male: 'Nam',
      female: 'Nữ',
    },
    infomation: {
      avatar: 'Ảnh đại diện',
      chooseAvatar: 'Chọn ảnh đại diện',
      realName: 'Tên thật',
      notSet: 'Chưa đặt',
      gender: 'Giới tính',
      unknown: 'Không rõ',
      bindInfo: 'Thông tin liên kết',
      bound: 'Đã liên kết',
      none: 'Không có',
    },
    index: {
      recharge: 'Nạp tiền',
      withdraw: 'Rút tiền',
      myWallet: 'Ví của tôi',
      details: 'Chi tiết',
      balanceLabel: 'Số dư: ',
      personalReport: 'Báo cáo cá nhân',
      accountDetail: 'Chi tiết tài khoản',
      profileCenter: 'Trung tâm cá nhân',
      notice: 'Thông báo',
      customerService: 'Hỗ trợ trực tuyến',
      completeTaskFirst: 'Vui lòng hoàn tất đăng ký trước',
      contactServiceToRecharge: 'Vui lòng liên hệ hỗ trợ trực tuyến để nạp tiền',
      setPayoutCardFirst: 'Vui lòng thiết lập thẻ nhận tiền trước',
      featureDisabled: 'Tính năng này chưa mở',
      accountOffline: 'Tài khoản đã ngoại tuyến',
      loginRegister: 'Đăng nhập/Đăng ký',
      loginHint: 'Đăng nhập để xem',
    },
    setting: {
      basicInfo: 'Thông tin cơ bản',
      loginPassword: 'Mật khẩu đăng nhập',
      payPassword: 'Mật khẩu thanh toán',
      payPasswordAlreadySet: 'Mật khẩu thanh toán đã được đặt!',
      signOut: 'Đăng xuất',
    },
    gameRecord: {
      betAmount: 'Số tiền cược: {money}',
      betTime: 'Thời gian cược: {time}',
      settleTime: 'Thời gian quyết toán: {time}',
    },
    withdrawRecord: {
      amount: 'Số tiền rút: {money}',
      desc: 'Ghi chú rút tiền: {desc}',
      submitTime: 'Thời gian yêu cầu: {time}',
      reviewTime: 'Thời gian duyệt: {time}',
    },
    report: {
      profitLabel: 'Lãi/Lỗ',
      formulaTip: 'Lãi/Lỗ = tiền thắng - tiền cược + tiền nạp - tiền rút',
      playAmount: 'Tiền cược',
      rechargeAmount: 'Tiền nạp',
      withdrawAmount: 'Tiền rút',
      winAmount: 'Tiền thắng',
    },
    service: {
      contact: 'Liên hệ ngay',
      slogan: 'Bạn có thể liên hệ với chúng tôi bất cứ lúc nào',
    },
  },
  video: {
    hallTitle: 'Rạp chiếu phim',
    hotRecommend: 'Gợi ý nổi bật',
    playCount: 'Lượt xem: {count}',
    playCountSuffix: '{count} lượt xem',
    rechargeToWatch: 'Vui lòng nạp tiền để xem video!',
  },
  recharge: {
    title: 'Nạp tiền',
    chooseCoin: 'Chọn loại tiền',
    address: 'Địa chỉ nhận tiền',
    copy: 'Sao chép địa chỉ',
    copied: 'Đã sao chép',
    amount: 'Số tiền nạp',
    uploadShot: 'Tải lên ảnh chụp chuyển khoản',
    submit: 'Gửi yêu cầu nạp tiền',
    pending: 'Chờ duyệt',
    done: 'Đã ghi có',
    rejected: 'Đã từ chối',
  },
  payMethod: {
    title: 'Chọn phương thức nhận tiền',
    bankCard: 'Thẻ ngân hàng',
    wallet: 'Ví tiền mã hóa',
    unbind: 'Gỡ liên kết',
    bindNew: 'Liên kết địa chỉ mới',
    confirmUnbind: 'Xác nhận gỡ phương thức nhận tiền này?',
    payPassword: 'Mật khẩu rút tiền',
    wrongPassword: 'Mật khẩu rút tiền không đúng',
    chooseFirst: 'Vui lòng chọn phương thức nhận tiền trước',
  },
  router: {
    Index: { title: 'Trang chủ' },
    Home: { title: 'Trang chủ' },
    Choose: { title: 'Người đồng hành' },
    List: { title: 'Danh sách người đồng hành' },
    Profile: { title: 'Chi tiết người đồng hành' },
    Mine: { title: 'Cá nhân' },
    Video: { title: 'Video' },
    Game: { title: 'Trò chơi' },
    Login: { title: 'Đăng nhập' },
    Register: { title: 'Đăng ký' },
    ServiceOnline: { title: 'Dịch vụ khách hàng' },
    ServicePage: { title: 'Dịch vụ khách hàng' },
    Setting: { title: 'Cài đặt' },
    Infomation: { title: 'Thông tin cá nhân' },
    Setname: { title: 'Đổi tên thật' },
    Setsex: { title: 'Đổi giới tính' },
    SetPayPassword: { title: 'Mật khẩu thanh toán' },
    SetLoginPassword: { title: 'Mật khẩu đăng nhập' },
    Lottery: { title: 'Xổ số' },
    Notice: { title: 'Thông báo' },
    PlayVideo: { title: 'Phát video' },
    Setbank: { title: 'Thêm thẻ nhận tiền' },
    BindCard: { title: 'Thêm thẻ nhận tiền' },
    Withdraw: { title: 'Rút tiền' },
    Recharge: { title: 'Nạp tiền' },
    Personalreport: { title: 'Báo cáo cá nhân' },
    WithdrawRecord: { title: 'Lịch sử rút tiền' },
    AccountDetail: { title: 'Chi tiết tài khoản' },
    GameRecord: { title: 'Lịch sử trò chơi' },
  },
  captcha: {
    placeholder: 'Mã xác nhận hình ảnh',
    refresh: 'Nhấn để làm mới',
    error: 'Mã xác nhận không chính xác',
    required: 'Vui lòng nhập mã xác nhận',
  },
  login: {
    title: 'Đăng nhập',
    usernamePlaceholder: 'Vui lòng nhập tên đăng nhập',
    passwordPlaceholder: 'Vui lòng nhập mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    noAccountRegister: 'Chưa có tài khoản? Đăng ký ngay',
    submit: 'Đăng nhập',
  },
  register: {
    title: 'Đăng ký',
    usernamePlaceholder: 'Vui lòng nhập tên đăng nhập (6-12 chữ cái hoặc chữ số)',
    passwordPlaceholder: 'Vui lòng nhập mật khẩu đăng nhập (6-12 chữ cái hoặc chữ số)',
    codePlaceholder: 'Vui lòng nhập mã mời',
    protocol: 'Tôi đã đọc và đồng ý các điều khoản của "Thỏa thuận mở tài khoản"',
    submit: 'Đăng ký',
    codeRequired: 'Vui lòng nhập mã mời!',
    agreementRequired: 'Vui lòng tích chọn thỏa thuận mở tài khoản bên dưới!',
  },
}
